import { useCallback } from 'react';
import { copyText } from '../utils/clipboard';

export interface UseClipboardOptions {
  onSuccess?: () => void;
  onError?: () => void;
}

/**
 * 剪贴板复制 Hook。
 * 返回 copy(text) 方法，复制成功后调用 onSuccess，失败调用 onError。
 * 可在调用方传入 toast 等 UI 反馈，例如：
 * useClipboard({ onSuccess: () => toast.success('已复制'), onError: () => toast.error('复制失败') })
 */
export function useClipboard(options: UseClipboardOptions = {}): {
  copy: (text: string) => Promise<boolean>;
} {
  const { onSuccess, onError } = options;

  const copy = useCallback(
    async (text: string): Promise<boolean> => {
      const ok = await copyText(text);
      if (ok) {
        onSuccess?.();
      } else {
        onError?.();
      }
      return ok;
    },
    [onSuccess, onError]
  );

  return { copy };
}
